import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { ErrorMessages } from '@bingads-webui-react/validation';
// import { withComponentErrorLogging } from '@bingads-webui-campaign-react/global-error-options';
import { DisplayAdsContainer } from './display-ads-container';
import { AdPreview } from './ad-preview';

const getAdsStepStyles = (/* components, theme */) => ({
  displayAdPanelRoot: {
    marginTop: 20,
    width: 500,
    minHeight: 181,
    padding: 20,
    paddingBottom: 20,
    background: '#FFFFFF',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: 6,
    '& .image-list-item-status-indicator': {
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)',
      borderRadius: 6,
      width: '170px !important',
      height: '96px !important',
      paddingTop: '10px !important',
      '&:hover': {
        '& .edit-button': {
          display: 'none',
        },
      },
      '& .placeholder-content': {
        color: 'white !important',
      },
    },
    '& .error': {
      width: 400,
      marginTop: 20,
      float: 'left',
    },
    '& .image-experience-content': {
      width: 170,
      '& .col-sm-3': {
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)',
        borderRadius: 6,
        width: '170px !important',
        height: '96px !important',
        paddingTop: '10px !important',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        alignItems: 'center',
        '&:hover': {
          '& .edit-button': {
            display: 'none',
          },
        },
        '& .placeholder-content': {
          color: 'white !important',
        },
        '& .ms-Button': {
          width: 56,
          height: 24,
          marginTop: 10,
        },
        '& .image-list-content': {
          width: '170px !important', // fixed for 16:9 aspect ratio
          border: 'none !important',
          padding: '0px !important',
        },
      },
    },
    '& .image-section-label': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .image-list-label': {
      fontWeight: 600,
    },
    '& .image-list-content': {
      width: '170px !important', // fixed for 16:9 aspect ratio
      border: 'none !important',
      padding: '0px !important',
    },
    '& .image-list-item-video': {
      position: 'relative',
      width: '170px !important', // fixed for 16:9 aspect ratio
      '&:hover': {
        '& .edit-button': {
          display: 'flex',
        },
      },
      '& .placeholder-content': {
        color: 'black !important',
      },

    },
    '& .image-item-ratio-label': {
      paddingTop: 10,
    },
    '& .thumbnail-preview': {
      borderRadius: 6,
      filter: 'drop-shadow(0px 0.6px 1.8px rgba(0, 0, 0, 0.1)) drop-shadow(0px 3.2px 7.2px rgba(0, 0, 0, 0.13))',
      width: '170px !important',
      height: '96px !important',
    },
  },
  selectedPanel: {
    border: '1px solid #0078D4',
  },
  displayAdPanelHeader: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  displayAdPanelButton: {
    justifyContent: 'flex-end',
    display: 'none',
    cursor: 'pointer',
    borderRadius: 99,
    background: '#FFFFFF',
    width: 32,
    height: 32,
  },
  displayAdPanelButtonContainer: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    columnGap: '2px',
    display: 'flex',
  },
  adPreviewSizeTitle: {
    fontSize: 18,
    fontWeight: 600,
  },
  previewContainer: {
    height: 280,
    width: 498,
  },
  adPreviewSizeHeader: {
    height: 40,
  },
  adPreviewPanel: {
    width: 540,
    padding: 20,
    paddingBottom: 20,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  displayAd: {
    borderRadius: '6px',
    filter: 'drop-shadow(0px 0.6px 1.8px rgba(0, 0, 0, 0.1)) drop-shadow(0px 3.2px 7.2px rgba(0, 0, 0, 0.13))',
  },
  previewTag: {
    marginTop: 10,
  },
  emptyPreview: {
    width: '100%',
    height: '100%',
    backgroundColor: '#F3F2F1',
    borderRadius: 6,
  },
  pagination: {
    paddingTop: 10,
    width: '100%',
  },
  pageControls: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '10px',
  },
  paginationIndicatorDot: {
    height: 8,
    width: 8,
    borderRadius: '50%',
    display: 'inline-block',
    cursor: 'pointer',
  },
  paginationButton: {
    height: 8,
    width: 8,
    opacity: 0,
  },
  paginationIndicator: {
    display: 'flex',
    columnGap: '2px',
  },
  displayAdPanelContent: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  placementInfoTile: {
    paddingTop: 20,
    marginLeft: 10,
  },
});

const containerStyle = {
  display: 'flex',
  '& .image-list-content': {
    border: 'none !important',
    padding: '0px !important',
  },
};

export const AdEditor = ({
  aid,
  cid,
  i18n,
  perfMarker,
  permissions,
  adsModel,
  onAdsValidation,
  oDataConfig,
  resetFields,
  serverErrors,
  isLoadingImage,
}) => (
  <div style={containerStyle}>
    <div>
      <DisplayAdsContainer
        aid={aid}
        cid={cid}
        i18n={i18n}
        permissions={permissions}
        perfMarker={perfMarker}
        ads={adsModel.data}
        onAdsValidation={onAdsValidation}
        oDataConfig={oDataConfig}
        disablePagination
        customStyleFunction={getAdsStepStyles}
        useCustomStyleFunction
        resetFields={resetFields}
        isAdGridEditorMode
        isLoadingImage={isLoadingImage}
      />
      <ErrorMessages messages={serverErrors ? serverErrors.map(error => error.message) : []} />
    </div>
    <AdPreview
      i18n={i18n}
      onUpdateCurrentVideoIndex={() => _.noop}
      ads={adsModel}
      disablePagination
      customStyleFunction={getAdsStepStyles}
      useCustomStyleFunction
    />
  </div>);

AdEditor.propTypes = {
  containerStyle: PropTypes.shape({}).isRequired,
  permissions: PropTypes.shape({}).isRequired,
  aid: PropTypes.string.isRequired,
  cid: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  perfMarker: PropTypes.shape({}).isRequired,
  adsModel: PropTypes.shape({
    data: PropTypes.shape({}),
  }).isRequired,
  onAdsValidation: PropTypes.func.isRequired,
  oDataConfig: PropTypes.shape({}).isRequired,
  resetFields: PropTypes.bool.isRequired,
  serverErrors: PropTypes.shape({}),
  isLoadingImage: PropTypes.bool.isRequired,
};

AdEditor.defaultProps = {
  serverErrors: null,
};

/*
const AdEditorWithErrorLogging = withComponentErrorLogging(
  AdEditor,
  'XandrVideoAdsAdEditing'
);

export { AdEditorWithErrorLogging as AdEditor };
*/
